import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPlatformApi } from '../utils/platformApi';
import { getOwnedSchoolIdForBilling } from '../utils/activeSchool';
import { formatDate } from '../utils/dateFormat';

export default function ActiveStudentsModal({ open, onClose }) {
    const { t } = useTranslation(['activeStudents', 'common']);
    const [students, setStudents] = useState([]);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) load();
    }, [open]);

    async function load() {
        setLoading(true);
        try {
            const api = createPlatformApi();
            const schoolId = getOwnedSchoolIdForBilling();
            const res = await api.get('/platform/billing/active-students', {
                params: schoolId ? { schoolId } : {}
            });
            setStudents(res.data.students || []);
            setCount(res.data.count || 0);
        } catch {
            setStudents([]);
        }
        setLoading(false);
    }

    async function archiveStudent(id, name) {
        if (!window.confirm(t('activeStudents:archiveConfirm', { name }))) return;
        try {
            const api = createPlatformApi();
            await api.post(`/student/${id}/archive`);
            await load();
            alert(t('activeStudents:archivedSuccess'));
        } catch (err) {
            alert(err.response?.data?.message || t('activeStudents:archiveError'));
        }
    }

    if (!open) return null;

    const filtered = students.filter((s) =>
        !search || (s.fullName || '').toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={overlay} onClick={onClose}>
            <div style={modal} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>{t('activeStudents:title', { count })}</h3>
                    <button type="button" onClick={onClose} style={closeBtn}>×</button>
                </div>
                <input
                    placeholder={t('activeStudents:searchPlaceholder')}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ width: '100%', margin: '12px 0', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
                {loading ? (
                    <p>{t('activeStudents:loading')}</p>
                ) : (
                    <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', color: '#888' }}>
                                <th style={th}>{t('activeStudents:colName')}</th>
                                <th style={th}>{t('activeStudents:colSchool')}</th>
                                <th style={th}>{t('activeStudents:colActivity')}</th>
                                <th style={th} />
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((s) => (
                                <tr key={s.id} style={{ borderTop: '1px solid #eee' }}>
                                    <td style={td}>{s.fullName}</td>
                                    <td style={td}>{s.schoolName}</td>
                                    <td style={td}>
                                        {s.lastActivity ? formatDate(s.lastActivity) : '—'}
                                        <br />
                                        <small style={{ color: '#888' }}>{s.activityType}</small>
                                    </td>
                                    <td style={td}>
                                        <button
                                            type="button"
                                            onClick={() => archiveStudent(s.id, s.fullName)}
                                            style={{ fontSize: '12px', color: '#c0392b', border: 'none', background: 'none', cursor: 'pointer' }}
                                        >
                                            {t('activeStudents:archive')}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

const overlay = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
};
const modal = {
    background: '#fff', borderRadius: '16px', padding: '24px',
    maxWidth: '720px', width: '95%', maxHeight: '80vh', overflow: 'auto'
};
const closeBtn = { border: 'none', background: 'none', fontSize: '28px', cursor: 'pointer', lineHeight: 1 };
const th = { padding: '8px 4px' };
const td = { padding: '10px 4px' };
